<template>

  <div>

    <master-data-form ref="CreateForm" mode="create" :on-update="reload"/>
    <master-data-form ref="UpdateForm" mode="update" :on-update="reload"/>
    <template-appt-form ref="TemplateApptForm"/>
    <template-appt-form ref="TemplateApptUpdateForm" mode="Update" :on-update="reload"/>


    <md-card  class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-5">

          </div>
          <div>
            <!--
            <div class="md-layout-item md-small-size-100">
            <div class = "inputBox" >
              <md-field>
                <label>Transloading Yard</label>
                <md-input v-model="DataForm.transloadingYard" disabled @keyup.enter="doSearch('0')"/>
              </md-field>
            </div>
            </div>
            <div class="md-layout-item md-small-size-100">
            <div class = "inputBoxInbound" >
              <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Receiving Windows"
                                                :init-value="DataForm.recWindow"
                                                :watchValueId="DataForm.recWindow"
                                                :on-item-changed="handleWindowsChanged"
                                                >
            </auto-complete-master-data-select>
            </div>
            </div>
            -->

              <md-field>
                <label>Transloading Yard</label>
                <md-input v-model="DataForm.transloadingYard" disabled @keyup.enter="doSearch('0')"/>
              </md-field>

              <auto-complete-master-data-select id="recwin"
                                                group="REC_WINDOW"
                                                label="Receiving Windows"
                                                :init-value="DataForm.recWindow"
                                                :watchValueId="DataForm.recWindow"
                                                :on-item-changed="handleWindowsChanged"
                                                >
            </auto-complete-master-data-select>

          </div>
          
          <div class="md-layout-item md-size-25">
            <md-checkbox v-model="showOnlyActive">
              <label>Show Only Active Items</label>
            </md-checkbox>
          </div>

          <div style="margin-left:100px;">
            <md-button class="md-raised optionExtender" @click="doNew">New</md-button>
          </div>

          <div class="search2" style="margin-left:100px;">
            <md-button class="btn-search-schedule md-primary md-raised optionExtender" @click="doSearch">Search</md-button>
          </div>

          <div>
            <md-button class="md-raised optionExtender" @click="doClear">Clear</md-button>
          </div>
          

        </div>
      </md-card-content>
    </md-card>
    

    <br/>

    <calling-api path="/api/w/masterData">

      <pagination :items="getSortedMasterDatas">
        <template slot-scope="{pageItems}">
          <md-card class="data-table-container">
             <div class="outer-container">
              <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <!--<th class="header-cell w2"></th>-->
                      <!--<th class="header-cell w9">Appointment Id</th>-->
                      <th class="header-cell w4">Yard</th>
                      <th class="header-cell w3">Rec Window</th>
                      <th class="header-cell w4">Dock Type</th>
                      <th class="header-cell w2">Week Day</th>
                      <!-- <th class="header-cell w5">Day Desc</th> -->
                      <th class="header-cell w3">Time</th>
                      <!--<th class="header-cell w5">Sort time</th>-->
                      <th class="header-cell w5">External Trucker</th>
                      <!--<th class="header-cell w3">To</th>-->
                      <!--<th class="header-cell w3">Freq</th>-->
                      <!--<th class="header-cell w3">Addl Load</th>-->
                      <!-- <th class="header-cell w3">Rec Window Desc</th> -->
                      <!-- <th class="header-cell w3">Row</th> -->
                      <th class="header-cell w2-5">Active</th>
                      <!--<th class="header-cell w5">Group</th>-->
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <!--<td class="body-cell w2">
                        <md-button @click="toggleRemove(item)" class="md-icon-button">
                          <md-icon>delete</md-icon>
                        </md-button>
                      </td>-->
                      <!--<td class="body-cell w9">{{item.tagId}}</td>-->
                      <th class="header-cell w4">{{item.transYard}}</th>
                      <th class="header-cell w3">{{item.recWindow}}</th>
                      <th class="header-cell w4">{{item.dockType}}</th>
                      <th class="header-cell w2">{{item.weekDay}}</th>
                      <!-- <th class="header-cell w5">{{item.weekDayDesc}}</th> -->
                      <th class="header-cell w3">{{item.from}}</th>
                      <!--<th class="header-cell w5">{{item.to}}</th>-->
                      <th class="header-cell w5">{{item.extTrucker}}</th>
                      <!--<th class="header-cell w3">{{item.to}}</th>-->
                      <!--<th class="header-cell w3">{{item.appFreq}}</th>-->
                      <!--<th class="header-cell w3">{{item.additionLoad}}</th>-->
                      <!-- <th class="header-cell w3">{{item.recWindowDesc}}</th> -->
                      <!-- <td class="body-cell w3">{{item.tagName}}</td> -->
                      <td class="body-cell w2-5">{{item.active}}</td>
                      <!--<td class="body-cell w5">{{item.group}}</td>-->
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </md-card>

        </template>
      </pagination>
    </calling-api>
  </div>

</template>
<style scoped>
.inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 5px 5px 5px 5px;
    margin-top: 5px;
}

.inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 6px 6px 6px 6px;
    margin-top: 5px;
    background-color: #e0eff7;
      
}

.inputBoxSpace {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 200px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  };
.inputBoxDouble {
    /* border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px; */
    width: 400px;
    justify-content: space-around;
    display: flex;
  flex-direction: row;
  };
  .inputBoxInbound {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  };
  
  .inputBoxInbound:hover {
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
    background-color: #e0eff7;
  };

  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-size: 23px;
    display: inline-block;
    background-color: lightgray;
    margin-left: 300px;
    margin-top: 15px;
    -moz-osx-font-smoothing: grayscale;
  };
  #divider {
    height: 50px;
    width: 5px;
    background-color: black;
    display: inline-block;
  };
  .optionExtender {
    margin-left: 300px;
  };
  .optionExtender:hover{opacity:0.5};
  .searchTagName {
    margin-top: -15px;
    margin-left: 50px;
    display: inline-block;
  };
  .search {
    margin-left:10px;
  };
  .search2 {
    margin-left:100px;
  };
</style>
<script>
  import MasterDataForm from '../components/MasterDataForm.vue';
  import TemplateApptForm from '../components/TemplateApptForm.vue';

  import MasterDataSelectForm from '../components/MasterDataSelectForm.vue';
  import TemplateApptUpdateForm from '../components/TemplateApptForm.vue';
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialDataForm = () => ({
    group: "T_APP_MASTER",
    tagId: null,
    tagName: null,
    transloadingYard: 1010001,
    recWindow: null
 
  });

  const getInitSaveForm = () => ({
    group: "T_APP_MASTER",
    tagId: null,
    tagName: null,
    transloadingYard: null,
    recWindow: null,
    extTrucker: null,
    from: null,
    to: null
  });

  const getInitSearchRequest = () => ({
    group: "T_APP_MASTER",
    tagId: null,
    tagName: null,
    transloadingYard: 1010001,
    recWindow: null
  });

  export default {
    data: () => ({
      selectedGroup: "T_APP_MASTER",
   
      showOnlyActive: true,
      isload: false,
      isApp: false,
      isTApp: true,
      isGeneral: false,
      isLocation: false,
      isCarrier: false,
      isCustomer: false,
      isRoute: false,
      isVendor: false,
      isLease: false,
      isRateBill: false,
      isRateCost: false,
      masterDatas: [],
      DataForm: getInitialDataForm(),
      searchRequest: getInitSearchRequest(),
      SaveForm: getInitSaveForm(),
      tagId: '',
      selectedGroup: "T_APP_MASTER",
      selectedItem: []
    }),
    components: {
      MasterDataForm,
      MasterDataSelectForm,
      TemplateApptForm,
      TemplateApptUpdateForm,
    },
    computed: {
      ...mapGetters([
    
      ]),
      filteredMasterDatasByActive() {
        if (this.showOnlyActive) {
          return _(this.masterDatas)
            .filter(it => it.active);
        }
        return this.masterDatas;
      },
      getAllMasterGroups() {
        console.log("getAllMasterGroups");
        return _(this.filteredMasterDatasByActive || [])
          .chain()
          .pluck('group')
          .uniq()
          .sortBy(it => it)
          .value();
      },
      getFilteredMasterDatas() {
        //this.isload = false;
        console.log(JSON.stringify(this.searchRequest));
        if (!this.DataForm.tagId)
           this.DataForm.tagId = '';
        if (!this.DataForm.tagName)
           this.DataForm.tagName = '';

        console.log("getFilteredMasterDatas tagId: " + this.DataForm.tagId);
        console.log("getFilteredMasterDatas tagName: " + this.DataForm.tagName);
     



  
        console.log("getFilteredMasterDatas isLoad: " + this.isload);
        if (this.isload)
        {
           console.log("tagId: " + this.DataForm.tagId.toString());
           console.log("tagName: " + this.DataForm.tagName.trim());
           console.log("transloadyard: " + this.DataForm.transloadingYard);
           console.log("recWindow: " + this.DataForm.recWindow);
           return  _(this.filteredMasterDatasByActive)
            .filter(it => (((this.selectedGroup) && (it.group === this.selectedGroup)) || ((!this.selectedGroup) && (it.group !== null)))
                  && (((this.DataForm.tagId !== '') && (it.tagId.includes(this.DataForm.tagId))) || ((this.DataForm.tagId === '') && (it.tagId !== null)))
                  //&& (((this.DataForm.recWindow !== '') && (it.recWindow.includes(this.DataForm.recWindow))) || ((this.DataForm.recWindow === '') || (it.recWindow != null)))
                  && ( this.DataForm.recWindow == null || it.recWindow === this.DataForm.recWindow.toString())
                  && (((this.DataForm.tagName !== '') && (it.tagName.trim().includes(this.DataForm.tagName.trim()))) || ((this.DataForm.tagName === ''))   )
            )
                     
        }
        else
        {
          console.log("isLoad is false: " + this.isload);
          if (this.selectedGroup)
           return _(this.filteredMasterDatasByActive)
               .filter(it => it.group === this.selectedGroup);
          else
           return _(this.filteredMasterDatasByActive);
        }

      },
      getSortedMasterDatas() {
          return _(this.getFilteredMasterDatas)
            .sortBy(it => it.to);
      },
    },
    watch: {

      selectedGroup() {
        //if (this.isload) {
        switch(this.selectedGroup) {
          case "T_APP_MASTER":
             this.$nextTick(() => {
               this.isApp = false; 
               this.isTApp = true;
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false
             });
             break;

          default:
             this.$nextTick(() => {
               this.isApp = false; 
               this.isTApp = true;
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false
             });
        }
        //}
        //this.isload = false;
      },
      masterDatas() {
        this.$nextTick(() => {
          this.updateTableHeight();
        });
      },
    },
    async mounted() {
      await this.reload();
    },
    methods: {

      async reload() {
        //const masterDatas = await api.post('/api/w/masterData',
        const masterDatas = await newAPIPost('/api/w/masterData',
        {groups:[
          "T_APP_MASTER"

          ]});
        this.masterDatas = masterDatas;
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },
      handleWindowsChanged(id) {
        console.log("rec win: " + id);
        this.DataForm.recWindow = id;
      },

      toggleCreate() {
        this.$refs.MasterDataSelectForm.openDialog();
      },
      toggleUpdate(item) {
        this.$refs.TemplateApptUpdateForm.openDialog(item);
      },
      toggleRemove(item) {
        
      },
      doNew() {
        this.$refs.TemplateApptForm.openDialog();
      },


      doSearch() {
        console.log("reload datagrid");
        console.log(this.DataForm.tagId);
        this.$nextTick(() =>
        this.isload = true);
        //this.isload = true
        
      },
      doClear() {
        this.isload = false;
        //console.log("tagId: " + document.getElementById("tagId").innerHTML);
        //console.log("tagId value: " + document.getElementById("tagId").value);
        //console.log("tagName value: " + document.getElementById("tagName").value);
        console.log("doClear isload: " + this.isload);
        this.selectedGroup = "T_APP_MASTER";
        this.DataForm.group = "T_APP_MASTER";
        this.DataForm.tagId = '';
        this.DataForm.tagName = '';

        this.DataForm = getInitialDataForm();         
        this.searchRequest = getInitSearchRequest();
        this.handleWindowsChanged(null);
         _(this.$el.querySelectorAll('button.md-input-action.md-clear')).each((it) => {
           it.click();
         });

        console.log(this.DataForm);
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      
    },
  };


</script>
